import * as types from "./types";

export const setVideoStatus = (value) => {
  return {
    type: types.SET_VIDEO_STATUS,
    payload: value,
  };
};

export const setAudioStatus = (value) => {
  return {
    type: types.SET_AUDIO_STATUS,
    payload: value,
  };
};

export const setRoomStatus = (value) => {
  return {
    type: types.SET_ROOM_STATUS,
    payload: value,
  };
};

export const setConnectedRoom = (value) => {
  return {
    type: types.SET_CONNECTED_ROOM,
    payload: value,
  };
};

export const setCurrentQuestion = (value) => {
  return {
    type: types.SET_CURRENT_QUESTION,
    payload: value,
  };
};

export const saveInprogressEvidenceInstance = (value) => {
  return {
    type: types.EVIDENCE_INPROGRESS_INSTANCE,
    payload: value,
  };
};
export const setIsEvidenceCompleted = (value) => {
  return {
    type: types.IS_EVIDENCE_COMPLETED,
    payload: value,
  };
};

export const setDnsdSid = (value) => {
  return {
    type: types.SET_DNSD_SID,
    payload: value,
  };
};

export const setCallEnded = (value) => {
  return {
    type: types.SET_CALL_ENDED,
    payload: value,
  };
};

export const setQuestionPayloadInStore = (value) => {
  return {
    type: types.SET_QUESTION_PAYLOAD,
    payload: value,
  };
};

export const setAuditSubmitted = (value) => {
  return {
    type: types.SET_AUDIT_SUBMITTED,
    payload: value,
  };
};

export const setMultipleCamera = (value) => {
  return {
    type: types.SET_MULTIPLE_CAMERA,
    payload: value,
  };
};
export const setSelectedCamera = (value) => {
  return {
    type: types.SET_SELECTED_CAMERA,
    payload: value,
  };
};

export const setShowQuestion = (value) => {
  return {
    type: types.SET_SHOW_QUESTION,
    payload: value,
  };
};

export const setMutedParticipentContext = (value) => {
  return {
    type: types.SET_MUTED_PARTICIPENT_CONTEXT,
    payload: value,
  };
};

export const setMutedVideoParticipentContext = (value) => {
  return {
    type: types.SET_MUTED_VIDEO_PARTICIPENT_CONTEXT,
    payload: value,
  };
};
